import { render, staticRenderFns } from "./EntityTypeItemsEmpty.vue?vue&type=template&id=e3768b62&"
import script from "./EntityTypeItemsEmpty.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EntityTypeItemsEmpty.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports